/* eslint-disable no-restricted-imports */

import * as React from "react";
import ActionButton, { ActionButtonType } from "components/Button";
import { DialogLayout } from "components/DialogLayout/DialogLayout";
import { Grid, Dialog } from "@material-ui/core";
import { Errors } from "components/DataBaseComponent";
import { ProjectResource } from "client/resources";
import KeyboardHandler, { Key } from "components/KeyboardHandler";
import { CommitMessageWithDetails } from "areas/projects/components/VersionControl/CommitMessageWithDetails";
import { CommitSummaryAndDetails, CommitSummaryAndDetailsProps } from "../../VersionControl/CommitDialog";
import { Note } from "components/form";
const styles = require("./style.less");

interface CommitDialogProps {
    open: boolean;
    defaultSummary: string;
    commitMessage: CommitMessageWithDetails;
    setCommitMessage: (commitMessage: CommitMessageWithDetails) => void;
    errors?: Errors;
    project: ProjectResource;
    onClose: () => void;
    onNext: () => Promise<boolean | undefined>;
}

const CommitMessageStep: React.FC<CommitSummaryAndDetailsProps> = (props) => {
    return (
        <>
            <Note>Configuring this project with version control will allow you to create branches and commit different versions to your repo.</Note>
            <CommitSummaryAndDetails {...props} />
        </>
    );
};

// TODO: Frontend and UX review - Once our functional equivalents are in place for DataBaseComponent, let's
// review this CommitDialog and see if we can get busy indicators showing here also.
const CommitDialog: React.FC<CommitDialogProps> = ({ open, commitMessage, defaultSummary, setCommitMessage, errors, project, onClose, onNext }) => {
    const commitChanges = async () => {
        onClose();
        await onNext();
    };

    const close = () => {
        onClose();
    };

    const actions = [<ActionButton key="Commit" label="Commit" title="Commit" onClick={commitChanges} type={ActionButtonType.Save} disabled={!commitMessage} />];
    const additionalActions = [<ActionButton key="Cancel" label="Cancel" title="Cancel" onClick={close} />];

    const onEnter = (event: KeyboardEvent): boolean => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const target: any = event.target ? event.target : event.srcElement;
        const tagName = target.tagName;
        if (tagName.toUpperCase() === "INPUT") {
            commitChanges();
            return true;
        }
        return false;
    };

    const onCtrlEnter = (event: KeyboardEvent) => {
        commitChanges();
        return true;
    };

    const keyboardRegistrations = [
        { key: Key.Enter, onKeyPressed: onEnter },
        { key: Key.CtrlEnter, onKeyPressed: onCtrlEnter },
    ];

    return (
        <Dialog open={open} fullWidth>
            <KeyboardHandler registrations={keyboardRegistrations}>
                <DialogLayout actions={actions} additionalActions={additionalActions} title={"Configure Version Control"} closeDialog={close}>
                    {open && (
                        <Grid container direction="column" alignItems="center" className={styles.commitDialog}>
                            <CommitMessageStep commitMessage={commitMessage} defaultSummary={defaultSummary} onCommitMessageChanged={(value: CommitMessageWithDetails) => setCommitMessage(value)} />
                        </Grid>
                    )}
                </DialogLayout>
            </KeyboardHandler>
        </Dialog>
    );
};

export default CommitDialog;
